import styled from 'styled-components';

export const NoAvailabilityStyled = styled.span`
  display: flex;
  border-radius: 999px;
  background: ${({ theme }) => theme.defaultColors.lighterGrey};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  padding: 7px 12px;
  font-size: 12px;
`;
